<template>
<v-layout row align-center wrap justify-space-around class="content-barChart">
	<BaseSelect
		class="select-accouting"
		label="Cuenta Contable"
		item-text="name"
		item-value="id"
		:items="records"
		v-model="moduleId"
		:value="moduleId"
		@input="setModule($event)"
		:height="38"
	/>
	<v-flex >
		<apexchart width="500" type="bar" :options="chartOptions" :series="series"></apexchart>
	</v-flex>
</v-layout>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import { mapGetters, mapActions } from 'vuex';
import BaseSelect from '@/components/shared/inputs/base-select';

async function created() {
	this.loadRecords(this.currentSubsidiary);
	this.loadData();
}

async function loadData() {
	const neWModule = localStorage.getItem('quipu::neWModule');
	try {
		const { data: response } = await this.$http.get(
			`accounting-seat-details/${neWModule}/${this.currentSubsidiary.id}`);
		const amountDebit
		= response.map(item => item.amountDebe).reduce((prev, curr) => prev + curr, 0);
		const amountCredit
		= response.map(item => item.amountHaber).reduce((prev, curr) => prev + curr, 0);
		this.debit = amountDebit;
		this.credit = amountCredit;
		const amountTotal = amountDebit - amountCredit;
		this.amount = amountTotal;
		this.series = [{
			name: 'Totales',
			data: [this.debit.toFixed(2), this.credit.toFixed(2), this.amount.toFixed(2)],
		}];
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		} else if (err.status === 400) {
			this.showNotification('Para visualizar la grafica de Barras, necesita elegir una cuenta contable', 'warning');
		}
	}
}
async function loadRecords(newSubsidiary) {
	try {
		const { data: records, headers } = await this.$http.get(
			`accounting-plan/${newSubsidiary.id}/subsidiary?status=1&limit=30&page=1`);
		this.lastPageSearcher = Number(headers['x-last-page']);
		this.records = [...records];
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		} else if (err.status === 400) {
			this.showNotification('Para visualizar la grafica de Barras, necesita elegir una cuenta contable', 'warning');
		}
	}
}
async function subsidiaryChange(newSubsidiary) {
	this.loadRecords(newSubsidiary);
	this.loadData();
}


function setModule(value) {
	this.moduleId = value;
	this.loadData();
	localStorage.setItem('quipu::neWModule', this.moduleId);
}

export default {
	name: 'barChart',
	components: {
		VueApexCharts,
		BaseSelect,
	},
	created,
	methods: {
		...mapActions('subsidiary', {
			$loadSubsidiaries: 'loadSubsidiaries',
			$setCurrentSubsidiary: 'setCurrentSubsidiary',
			$updateSubsidiaries: 'updateSubsidiaries',
		}),
		loadData,
		setModule,
		loadRecords,
		subsidiaryChange,
	},
	computed: {
		...mapGetters('subsidiary', [
			'currentSubsidiary',
		]),
	},
	data() {
		return {
			chartOptions: {
				chart: {
					id: 'basic-bar',
					animations: {
						speed: 200,
					},
				},
				plotOptions: {
					bar: {
						distributed: true,
					},
				},
				xaxis: {
					categories: ['Debe', 'Haber', 'Total'],
				},
			},
			series: [{
				name: 'series-1',
				data: [30, 40, 45],
			}],
			debit: 0,
			credit: 0,
			amount: 0,
			moduleId: 0,
			records: [],
		};
	},
	watch: {
		currentSubsidiary: subsidiaryChange,
	},
};
</script>
<style scoped lang="scss">
.content-barChart {
	@media (max-width: 768px) {
		width: 200px !important;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/shared/apexCharts/bar-chart.vue